import { dropGrupoQualidade } from 'utils/drops';

const getIndicadorQualidadeFilterFields = () => [
  { name: 'id', label: 'ID', type: 'number' },
  {
    name: 'grupo',
    label: 'Grupo',
    type: 'select',
    options: dropGrupoQualidade,
    multiple: true,
  },
  { name: 'descricao', label: 'Descrição', initial: true },
  { name: 'orientacao', label: 'Orientação' },
  {
    name: 'inivalid.i',
    column: 'inivalid',
    label: 'Início da Validade Inicial',
    type: 'date',
  },
  {
    name: 'inivalid.f',
    column: 'inivalid',
    label: 'Início da Validade Final',
    type: 'date',
  },
  {
    name: 'fimvalid.i',
    column: 'fimvalid',
    label: 'Fim da Validade Inicial',
    type: 'date',
  },
  {
    name: 'fimvalid.f',
    column: 'fimvalid',
    label: 'Fim da Validade Final',
    type: 'date',
  },
];

export default getIndicadorQualidadeFilterFields;
